import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import { Layout, Menu, Tooltip } from "antd";
import React, { useEffect, useState } from "react";
import { Link, Route, useHistory, useLocation } from "react-router-dom";
import { logoutApi } from "../api/logoutApi";
import { supportApi } from "../api/loginStudentApi";
import SurveyIcon from "../assets/img/sideBarIcon/surveyIcon";
import SurveyIcon2 from "../assets/img/sideBarIcon/surveyIcon2";
import StartTestIcon from "../assets/img/sideBarIcon/startTestIcon";
import StartTestIcon2 from "../assets/img/sideBarIcon/startTestIcon2";
import ProfileIcon from "../assets/img/sideBarIcon/profileIcon";
import ProfileIcon2 from "../assets/img/sideBarIcon/profileIcon2";
import HomeIcon from "../assets/img/sideBarIcon/homeIcon.jsx";
import HomeIcon2 from "../assets/img/sideBarIcon/homeIcon2";
import LogoutIcon2 from "../assets/img/sideBarIcon/logoutIcon2";
import CalibrationIcon from "../assets/img/sideBarIcon/calibrationIcon";
import CalibrationIcon2 from "../assets/img/sideBarIcon/calibrationIcon2";
import HelpAndSupportIcon from "../assets/img/sideBarIcon/helpAndSupportIcon";
import useWindowDimensions from "../Hooks/WindowDimensions";
import { LoginContext } from "../store/loginStore";
import smallLogo from "../assets/icon/smallLogo.svg";
import AppContent from "../appContent/AppContent";
import { getStudentData } from "../helper/localStorage";
import HelpAndSupport from "../components/helpAndSupport/helpAndSupport";
import AweIcon2 from "../assets/img/sideBarIcon/aweIcon2.jsx";
import AweIcon from "../assets/img/sideBarIcon/aweIcon.jsx";

const { Sider, Content } = Layout;

export default function PrivateHeader({ component, ...rest }) {
  const location = useLocation();
  const [menuNum, setMenuNum] = useState(["0"]);

  const [showHelp, setShowHelp] = useState(false);
  const [success, setSuccess] = useState(false);
  // const [timeoutId, setTimeOutId] = useState(null);

  const userEmail = getStudentData().data.master[0].email;
  const playerId = getStudentData().data.master[0].id;
  const firstName = getStudentData().data.master[0].firstname;
  const lastName = getStudentData().data.master[0].lastname;
  const { loginC, dispatchLogin } = LoginContext();
  const { supportData, loader } = loginC;
  console.log("userEmail", userEmail);
  console.log("playerId", playerId);
  console.log("firstname", firstName);
  console.log("lastName", lastName);

  const selectedKey = () => {
    switch (location.pathname.toString().split("/")[1]) {
      // FIXME needed to fix in the future
      case "dashboard": {
        return ["1"];
      }

      case "startTest": {
        return ["2"];
      }

      case "calibration": {
        return ["3"];
      }

      case "survey": {
        return ["4"];
      }

      case "profile": {
        return ["5"];
      }

      case "mappr_tracker": {
        return ["0"];
      }

      default: {
        return ["1"];
      }
    }
  };

  const projectMainLink = [
    {
      name: "MAPPR Tracker",
      link: "/mappr_tracker",
      tooltip: "",
      img: selectedKey()[0] !== "0" ? AweIcon2 : AweIcon,
      hoverImg: AweIcon,
    },
    {
      name: "MAPPR",
      link: "/mappr",
      tooltip: "All assessments",
      img: selectedKey()[0] !== "1" ? HomeIcon2 : HomeIcon,
      // hoverImg: HomeIcon,
    },
    {
      name: "Dashboard",
      link: "/startTest",
      tooltip: "My Assessments",
      img: selectedKey()[0] !== "2" ? StartTestIcon2 : StartTestIcon,
      // hoverImg: HomeIcon,
    },
    {
      name: "Calibration",
      link: "/calibration",
      tooltip: "Mini diagnostic assessments",
      img: selectedKey()[0] !== "3" ? CalibrationIcon2 : CalibrationIcon,
      // hoverImg: HomeIcon,
    },
    {
      name: "Survey",
      link: "/survey",
      tooltip: "Self-assessment of behavior and abilities",
      img: selectedKey()[0] !== "4" ? SurveyIcon2 : SurveyIcon,
      // hoverImg: HomeIcon,
    },
    {
      name: "Profile",
      link: "/profile",
      tooltip: "",
      img: selectedKey()[0] !== "5" ? ProfileIcon2 : ProfileIcon,
      // hoverImg: HomeIcon,
    },
  ];

  const history = useHistory();

  const { width } = useWindowDimensions();
  // const width = 500;
  console.log("width", width);
  const [collapsed, setCollapsed] = useState(width > 1120 ? false : true);
  useEffect(() => {
    setCollapsed(width > 1120 ? false : true);
  }, [width]);
  console.log("width", collapsed);

  const handleToggle = () => {
    setCollapsed(!collapsed);
  };

  const handleLogout = () => {
    logoutApi(dispatchLogin, history);
  };

  const handleHelpSubmit = (value) => {
    console.log(value);
    // value.email = value.email || userEmail;
    supportApi(value, dispatchLogin, playerId);
  };

  useEffect(() => {
    let flag = 0;
    if (supportData.status === "201") {
      flag = 1;
      setShowHelp(false);
      setSuccess(true);

      // setTimeOutId(
      //   setTimeout(() => {
      //     setSuccess(false);
      //   }, 3000)
      // );
    }
    return () => {
      if (flag === 1) {
        dispatchLogin({ type: "RESET_SUPPORT_DATA" });
      }
    };
  });

  return (
    <Layout>
      {width < 1120 && !collapsed && (
        <div className="full-wrapper" onClick={handleToggle}></div>
      )}
      {width < 1120 && collapsed && (
        <MenuUnfoldOutlined
          onClick={handleToggle}
          // className="trigger"
          className="trigger diff"
        />
      )}
      <Sider
        trigger={null}
        collapsible
        collapsed={
          // true
          collapsed
        }
        //don't remove comment below comment
        // width={width < 1120 ? 80 : 200}
        width={200}
        collapsedWidth={width < 1120 ? 0 : 80}
      >
        {collapsed ? (
          <MenuUnfoldOutlined
            onClick={handleToggle}
            style={{ position: "relative", left: "60px", top: "10px" }}
            className="trigger"
          />
        ) : (
          <MenuFoldOutlined
            style={{ position: "absolute", right: "10px", top: "10px" }}
            onClick={handleToggle}
            className="trigger"
          />
        )}

        <div
          className=""
          style={{
            padding: 11,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <img src={smallLogo} className="" 
            style={{
              width: "60px",
              height: "auto",
              objectFit: "contain",
            }} 
          alt="" />
        </div>

        <Menu theme="dark" mode="inline" selectedKeys={selectedKey()}>
          {projectMainLink.map((navBarLink, index) => {
            return (
              <Menu.Item
                key={index}
                onClick={() => {
                  width < 1120 && handleToggle();
                }}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  <Tooltip
                    title={collapsed ? "" : navBarLink.tooltip}
                    placement="right"
                  >
                    <Link to={navBarLink.link}>
                      <span className="anticon">
                        {/* <navBarLink.hoverImg /> */}
                        <navBarLink.img />
                        {/* <img src={navBarLink.img} alt="" className="" /> */}
                      </span>
                      <span>{navBarLink.name}</span>
                    </Link>
                  </Tooltip>
                </div>
              </Menu.Item>
            );
          })}
          <Menu.Item key="help and support" onClick={(e) => setShowHelp(true)}>
            <div style={{ display: "flex", alignItems: "center" }}>
              <span className="anticon">
                <HelpAndSupportIcon />
              </span>
              <span>{"Help & Support"}</span>
            </div>
          </Menu.Item>
          <Menu.Item key="" onClick={handleLogout}>
            <div style={{ display: "flex", alignItems: "center" }}>
              <span className="anticon">
                <LogoutIcon2 />
              </span>
              <span>Logout</span>
            </div>
          </Menu.Item>
        </Menu>
      </Sider>
      <HelpAndSupport
        showHelp={showHelp}
        setShowHelp={setShowHelp}
        success={success}
        setSuccess={setSuccess}
        dispatchLogin={dispatchLogin}
        loader={loader}
        LoadingOutlined={LoadingOutlined}
        userEmail={userEmail}
        playerId={playerId}
        firstName={firstName}
        lastName={lastName}
      />
      <Layout className="site-layout">
        <AppContent component={component} rest={rest} />
      </Layout>
    </Layout>
  );
}
